/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "No vender ni compartir mi información personal",
      "Bumble Date",
      "Nuestras apps",
      "Conócenos",
      "Empleos",
      "Contáctanos",
      "Inversionistas",
      "Tienda",
      "Empresa",
      "Descargar la app",
      "Accesibilidad en Bumble",
      "Normas",
      "Gestionar cookies",
      "Ley contra la esclavitud moderna",
      "Notificación de recopilación",
      "Política de Privacidad",
      "Condiciones de uso",
      "Legal",
      "Política de privacidad de la salud del consumidor de Washington",
      "Escanea el código QR para descargar la app de Bumble",
      "Rescindir contratos aquí",
      "Cerrar menú",
      "Abrir menú",
      "Selección de idioma",
      "Pie de página",
      "Accesibilidad en Bumble",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Empleo",
      "Google Play es una marca de Google LLC.",
      "Reglas",
      "Inversionistas",
      "Gestionar cookies",
      "Declaración sobre la Ley de Esclavitud Moderna",
      "Notificación de recopilación",
      "Política de privacidad",
      "Guía de citas por estaciones",
      "Condiciones de Uso",
      "La aplicación",
      "Política de privacidad de Washington Consumer Health",
      "Acerca de",
      "Embajadores",
      "Haz nuevas amistades y encuentra tu comunidad",
      "Haz networking y avanza en tu carrera",
      "Encuentra una relación, algo casual o cualquier cosa intermedia",
      "Blog",
      "Descubrir más",
      "Globalízate con el Modo Travel",
      "Date",
      "Funciones",
      "Compliments",
      "Utiliza Compliments para que sepa por qué te gusta.",
      "Descubre",
      "Una página personalizada que destaca a las personas más compatibles contigo, actualizada cada día.",
      "Modo Incógnito",
      "Utiliza el Modo Incógnito para ocultar tu perfil de la gente de tu oficina, de tus papás y de tu ex.",
      "Conexión inmediata",
      "¿Empezaron a hablar en un evento IRL de Bumble? Sigan la conversación en la app.",
      "Opening Moves",
      "Elige Opening Moves que animen a tu conexión a iniciar el chat, así no tendrás que hacerlo tú.",
      "Modo No Molestar",
      "Tómate un descanso con el Modo No molestar. Cuando te quieras volver a las citas, ya sabes dónde estamos.",
      "SuperSwipe",
      "¿Su perfil te encantó? Demuéstraselo con un SuperSwipe.",
      "Modo Travel",
      "Encuentra tu souvenir duty-free y conecta en cualquier parte del mundo con el Modo Travel.",
      "Videollamada",
      "Usa las videollamadas y llamadas de audio para ver si les gustaría conocerse en persona.",
      "App web",
      "¡Obtén la experiencia de Bumble directamente desde tu navegador!",
      "Descarga la app de Bumble",
      "BFF",
      "Seguridad",
      "Historias",
      "Ayuda",
      "Nuestra Tienda",
      "Principal",
      "Lanza algunos Compliments para destacar.",
      "Compliments",
      "Funciones diseñadas para crear un espacio de relaciones reales, respetuosas y significativas.",
      "Oculta tu perfil a tu jefa, familiares o a tus ex.",
      "Modo Incógnito",
      "Pon las dates en pausa con el Modo No molestar.",
      "Modo No Molestar",
      "¿Te gustó alguien? Díselo.",
      "SuperSwipe",
      "Explorar Date",
      "Disfruta tu snack duty-free y conecta donde vayas.",
      "Modo Travel",
      "Acércate lo más posible a la vida real sin salir de casa.",
      "Videollamadas",
      "Líderes que nos ayudan a llevar los valores de Bumble a sus comunidades en todo el país.",
      "Líderes de la comunidad",
      "Funciones diseñadas para ayudarte a encontrar a tu gente y conectar con lo que te apasiona.",
      "Organiza una reunión de grupo o descubre los eventos locales que se celebran en tu zona.",
      "Plans",
      "Explorar BFF",
      "Toda la orientación e inspiración que necesitas para ayudarte a encontrar el amor y la amistad.",
      "Tips e historias para ayudarte a construir las amistades que deseas.",
      "El Centro de la Amistad",
      "Desde Tokio hasta Toronto, descubre el amor que se encuentra en Bumble por todo el mundo.",
      "Historias de amor",
      "Planea la cita perfecta, sin importar cuándo, dónde o con quién sea la date.",
      "Guía de citas por estaciones",
      "Explorar historias",
      "Leer más",
      "Bumble en {{social_network}}",
      "Contacto",
      "Entrar",
      "(se abre en otra ventana)",
      "Preguntas",
      "Política de cookies",
      "Bumble - The Blog",
      "Empleo",
      "Chat",
      "Ciudades",
      "Gestionar cookies",
      "Copyright © 2006 – presente. Bumble. Todos los derechos reservados.",
      "Reporte de Confianza en las citas",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc. {{__EOL__}}Google Play es una marca de Google LLC. ",
      "Descargar",
      "Facebook",
      "Síguenos",
      "Centro de soporte",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble es parte de Bumble Inc.",
      "Política de privacidad",
      "Centro de seguridad",
      "Mapa del sitio",
      "Declaración del Modern Slavery Act",
      "Términos de uso",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
